import type { ReactNode } from 'react';
import { isNotFound } from '../../lib/httpError';
import NotFoundState from './NotFoundState';
import ErrorState from './ErrorState';

/**
 * #661 (F28) — what a detail page shows when its item did not load. Four
 * pages wrote this decision by hand with two rules, so a cut link
 * (`/tournaments/abc`, answered 400 `INVALID_UUID`) showed a Retry that could
 * not work, and the bout page drew a card with no link back.
 *
 * - No error, or an item that does not exist (`isNotFound()`): `NotFoundState`,
 *   with the text and a link to the list.
 * - Any other failure: `ErrorState` with Retry (#457).
 *
 * The page keeps its own loading skeleton and its back link: an early return
 * in this part would unmount the `useDeferredLoading` hold of the page.
 */
export default function LoadFailure({ error, onRetry, notFound }: {
  /** The error of the load, or a falsy value when the load ended with no item. */
  error: unknown;
  onRetry: () => void;
  notFound: { icon: ReactNode; title: string; to: string; linkLabel: string };
}) {
  return !error || isNotFound(error)
    ? <NotFoundState {...notFound} />
    : <ErrorState onRetry={onRetry} />;
}
